import React from "react";

export type DashboardTodo = {
  id: string;
  text: string;
  complete: boolean;
};

export default function Todo({
  todo,
  toggleComplete,
  onDelete
}: {
  todo: DashboardTodo;
  toggleComplete: () => void;
  onDelete: () => void;
}) {
  return (
    <div
      className={`dashboard-task-item ${todo.complete ? "is-complete" : ""}`}
    >
      <button
        type="button"
        className="dashboard-task-item__check"
        onClick={toggleComplete}
        aria-pressed={todo.complete}
        aria-label={todo.complete ? "Mark incomplete" : "Mark complete"}
      />
      <span className="dashboard-task-item__text">{todo.text}</span>
      <button
        type="button"
        className="dashboard-task-item__remove"
        onClick={onDelete}
        aria-label="Remove task"
      >
        <i className="simple-icon-close" aria-hidden />
      </button>
    </div>
  );
}
